<script>
import FormController from '@/modules/form-controller/FormController.vue';

export default {
  name: 'App',
  data() {
    return {
      divClass: null,
    };
  },
  components: {
    FormController
  },
  beforeMount() {
    if (document.querySelector('#app').classList.contains('inline-form')) {
      this.divClass = 'inline-form';
    } else if (document.querySelector('#app').classList.contains('inline-form1')) {
      this.divClass = 'inline-form1';
    } else if (document.querySelector('#app').classList.contains('new-lp-form')) {
      this.divClass = 'new-lp-form';
    }
  }
};
</script>

<template>
  <div id="app" :class="this.divClass ? this.divClass : ''">
    <FormController/>
  </div>
</template>

<style lang="scss">
@import './main.scss';
</style>
